import styled from 'styled-components'

export const MenuSelectStyle = styled.div`
  width: 100%;

  p {
    text-align: center;
    margin: 20px;
    font-size: ${({ theme }) => {
      return theme.fonts.size.superBig
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin
    }};
    color: ${({ theme }) => {
      return theme.colors.primary
    }};
  }

  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
  }

  button {
    width: 30%;
    height: 30px;
    color: ${({ theme }) => {
      return theme.colors.white
    }};
    font-family: inherit;
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin
    }};
    background-color: ${({ theme }) => {
      return theme.colors.success
    }};
    border: none;
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small
    }};
    cursor: pointer;
    transition: background-color 200ms ease-in-out;
    &:hover {
      background-color: ${({ theme }) => {
        return theme.colors.darkSuccess
      }};
    }
    &:disabled {
      background-color: ${({ theme }) => {
        return theme.colors.border
      }};
      cursor: not-allowed;
    }
  }

  .first {
    background-color: ${({ theme }) => {
      return theme.colors.primary
    }};
    &:hover {
      background-color: ${({ theme }) => {
        return theme.colors.darkPrimary
      }};
    }
  }

  .second {
    background-color: ${({ theme }) => {
      return theme.colors.normal
    }};
    &:hover {
      background-color: ${({ theme }) => {
        return theme.colors.darkNormal
      }};
    }
  }

  .third {
    background-color: ${({ theme }) => {
      return theme.colors.alert
    }};
    color: ${({ theme }) => {
      return theme.colors.black
    }};
    &:hover {
      background-color: ${({ theme }) => {
        return theme.colors.darkAlert
      }};
    }
  }

  @media screen and (max-width: 720px) {
    p {
      font-size: ${({ theme }) => {
        return theme.fonts.size.normal
      }};
    }
    button {
      font-size: ${({ theme }) => {
        return theme.fonts.size.small
      }};
    }
  }

  @media screen and (max-width: 480px) {
    p {
      font-size: ${({ theme }) => {
        return theme.fonts.size.small
      }};
    }
    button {
      font-size: ${({ theme }) => {
        return theme.fonts.size.superSmall
      }};
    }
  }
`
